import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CtaButtonsComponent } from 'src/app/components/cta-buttons/cta-buttons.component';
import { advancedPages } from '../advanced-data';
import { AdvancedService } from 'src/app/services/advanced/advanced.service';
import { SharedModule } from 'src/app/shared.module';

@Component({
  selector: 'app-poi-th',
  standalone: true,
  imports: [CtaButtonsComponent, SharedModule],
  templateUrl: './poi-th.component.html',
  styleUrl: './poi-th.component.scss',
})
export class PoiThComponent {
  advancedPages: string[] = advancedPages;

  constructor(
    private advancedService: AdvancedService,
    private router: Router
  ) {}

  changeIdCategory(category: string) {
    this.advancedService.updateIdCategory(category);
    this.router.navigate(['advanced/upload-id-th'], {
      queryParams: { pages: advancedPages.length, count: 1, type: category },
    });
  }
}
